import { IConsumptionDetailDTO, IRequestDTO } from "@/interface"
import { ConsumptionDetail } from "@/models/consumption/consumption-detail"
import { Pagination } from "@/models/commons/pagination"

export class ConsumptionDetailPage {
    public pagination: Pagination;
    public data: (ConsumptionDetail)[] | [];
    public path: string

    constructor(base: ConsumptionDetailPage) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IRequestDTO<IConsumptionDetailDTO>): ConsumptionDetailPage {
        return new ConsumptionDetailPage({
            pagination: Pagination.fromDto(dto),
            data: dto.data ? dto.data.map(data => ConsumptionDetail.fromDto(data)) : [],
            path: dto.path
        });
    }
}
